module.exports = __webpack_public_path__ + "img/20.bc46ab91.jpg";